import script from "./ContactButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactButton.vue?vue&type=script&setup=true&lang=js"

import "./ContactButton.vue?vue&type=style&index=0&id=f8cfc31a&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8cfc31a"]])

export default __exports__